<template>
  <element>
    <AppBar :title="$t('partSearchPage.title')" />
    <v-container>
      <LabelTextField :label="$t('partSearchPage.searchLabel')" />
      <span class="label">{{ $t('partSearchPage.orderLabel') }}</span>
      <v-combobox
          v-model="selected_part"
          v-bind:items="items"
          background-color="rgba(224, 231, 255, 0.2)"
          outlined
          dense
          light
        >
      </v-combobox>
      <PartTable v-bind:headers="headers" v-bind:partlist="partlist"></PartTable>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import LabelTextField from "@/components/common/LabelTextField.vue";
import PartTable from "@/components/common/PartTable.vue";

export default {
  name: "PartSearchPage",
  components: {
    AppBar,
    LabelTextField,
    PartTable,
  },
  props: {

  },
  data () {
    return {
      items: ['Engine', 'Side Mount', 'Turbo'],
      selected_part: 'Engine',
      partlist: [
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
        {
          item:"Short block",
          serial:"21202-12934"
        },
      ]
    }
  },
  computed: {
    headers : function () {
      return [
        this.$t('partSearchPage.table.col-1'), 
        this.$t('partSearchPage.table.col-2')
      ]
    }
  }
}
</script>

<style scoped>

</style>